import React from "react";
import Login from "./Login";
import {ModalProvider} from "../dialogs/ModalContext";

function LoginWrapper(props) {
    return (
        <div>
            <ModalProvider>
                <Login/>
            </ModalProvider>
        </div>
    )
}

export default LoginWrapper
